import React, { useContext, useEffect, useState } from "react";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

import EditorDialog from "./ProsesPermintaanMobilEditorDialog";
import { useDispatch } from "react-redux";
import UiContext from "../../store/ui-context";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { DataTable } from "primereact/datatable";
import {
  genTemplateBodyAction,
  genTemplateBodyDateTime,
  genTemplateBodyNumber,
  genTemplateBodyText,
} from "../../components/utils/TableTemplateBodyGenerator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import createFilterText from "../../utils/CreateFilterText";
import { decryptString } from "../../utils/EncryptDecryptData";
import { format } from "date-fns";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { Checkbox } from "primereact/checkbox";
import { Tag } from "primereact/tag";
import getLabelStatusPermintaanMobil from "../../utils/transport/LabelStatusPermintaanMobil";
import { RadioButton } from "primereact/radiobutton";
import useIsMobile from "../../hooks/useIsMobile";

const title = "Permintaan Mobil";
const fetchOrderBy = "tanggal_berangkat";
const fetchOrderMethod = "DESC";


const editorDefaultValue = {
  id: 0,
  pemohon_id: undefined,
  pemakai_id: undefined,
  tujuan_id: 0,
  tanggal_permintaan: undefined,
  tanggal_berangkat: undefined,
  jumlah_orang: 0,
  keterangan: "",
  keterangan_pemakai: "",
  keterangan_pnj: "",
  keterangan_disetujui: "",
  keterangan_diproses: "",
  status: 0,
};

const defaultVerifSetting = {
  jabatan_id: -1,
  pemakai: [],
  pnj: [],
  setujui: [],
  tolak: [],
  proses: [],
};

// status option:
// (-1) - Reject oleh Disetujui
// 0 - Kosong
// 1 - TTD Pemakai
// 2- TTD Penanggung jawab
// 3 - Diterima & TTD Disetujui
// 4 - Diprocses Kabag Transport

const PermintaanMobilPage = (props, { className }) => {
  const isMobile = useIsMobile();
  const uiContext = useContext(UiContext);
  const dispatch = useDispatch();
  const { requestGet, requestGetOne, requestDelete, loading } = useAPIRequest();

  const { loading: editorLoading, requestPost: editorRequestPost } =
    useAPIRequest();

  const [filterType, setFilterType] = useState("pending"); // archieve, pending, done
  const [filterArchieveDate, setFilterArchieveDate] = useState(new Date());

  const [firstLoad, setFirstLoad] = useState(false);
  const [paging, setPaging] = useState({
    page: 1,
    take: 100,
    filter: "",
    total: 0,
  });
  const [listData, setListData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [verifSetting, setVerifSetting] = useState(defaultVerifSetting);

  const [addNewMode, setAddNewMode] = useState(false);
  const [editorData, setEditorData] = useState({});
  const [editorError, setEditorError] = useState({});
  const [editorDialogShowed, setEditorDialogShowed] = useState(false);

  const userJSON = localStorage.getItem(
    process.env.REACT_APP_TAG + "user-Transport"
  );

  const user = userJSON
    ? JSON.parse(
      decryptString(
        localStorage.getItem(process.env.REACT_APP_TAG + "user-Transport")
      )
    )
    : null;

  // useEffect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    fetchListData({ page: 1, take: 10 });
    fetchVerifSetting();
  }, [dispatch]);

  // API call section

  const fetchVerifSetting = () => {
    return requestGet({
      fullUrl: `api/masterdata/verifsetting/data`,
      params: {
        filter: `label:contains:permintaan_pemakaian`,
        page: 1,
        take: 150,
      },
      onSuccess: ({ message, data }) => {
        if (data && data.length > 0) {
          const newVerifSetting = {
            ...defaultVerifSetting,
            // jabatan_id: user.data_karyawan.jabatan_id,
          };
          if (data) {
            for (const verifData of data) {
              const { id, label, jabatan_id } = verifData;

              const newVerifLabel = label
                .replace(`permintaan_pemakaian:`, "")
                .trim();
              newVerifSetting[newVerifLabel].push(jabatan_id);
            }
          }
          setVerifSetting(newVerifSetting);
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const fetchListData = async ({ page, take, filter }) => {
    if (loading) return;

    const _filter = filter ?? getFilter();

    return requestGet({
      fullUrl: `/api/pemakaian/permintaanpemakaian/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: fetchOrderBy,
        order_method: fetchOrderMethod,
        with_pemakai: 1,
        with_verif_pnj: 1,
        with_tujuan: 1,
        with_verif_pemakai: 1,
        with_verif_setujui: 1,
        with_verif_tolak: 1,
        "with_pemakaian_mobil,data_kendaraan": 1,
        "with_pemakaian_mobil,data_supir": 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListData(data);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const fetchDataPemakaianMobil = async ({ id }) => {
    if (loading) return;
    return requestGetOne({
      fullUrl: `/api/pemakaian/pemakaianmobil/one/${id}`,
      onSuccess: ({ message, data }) => { },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const deleteData = async ({ ids }) => {
    if (loading) return;

    return requestDelete({
      fullUrl: `/api/pemakaian/pemakaianmobil/delete`,
      ids: ids,
      onSuccess: ({ message, data }) => {
        // const newListData = listData.filter((el) => !ids.includes(el.id));
        // setListData(newListData);

        for (let id of ids) {
          const index = listData.findIndex(
            (el) => el.pemakaian_mobil_id === id
          );
          if (index >= 0) {
            const data = listData[index];
            data.pemakaian_mobil_id = null;
            data.data_pemakaian_mobil = null;
          }
        }

        uiContext.showSuccessMsg("Success", message);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // const saveData = async ({ data }) => {
  //   resetEditorError();
  //   if (loading) return;
  //   const valid = validateData();

  //   if (valid) {
  //     const body = data;

  //     // console.log("BODY", body);
  //     // return null;

  //     return editorRequestPost({
  //       fullUrl: `/api/pemakaian/pemakaianmobil/save`,
  //       body,
  //       isForm: false,
  //       onError: ({ message, data }) => {
  //         uiContext.showErrorMsg("Error", message);
  //         setEditorError(data);
  //       },
  //       onSuccess: ({ data, message }) => {
  //         uiContext.showSuccessMsg("Success", message);
  //       },
  //     });
  //   }
  //   return null;
  // };

  const savePemakaianMobilData = async ({ data }) => {
    resetEditorError();
    if (loading) return;
    const valid = validateData();

    if (valid) {
      const body = data;

      return editorRequestPost({
        fullUrl: `/api/pemakaian/pemakaianmobil/save`,
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
          setEditorError(data);
        },
        onSuccess: ({ data: _data, message }) => {
          _data.permintaan_pemakaian_id = data.permintaan_pemakaian_id;
          uiContext.showSuccessMsg("Success", message);
        },
      });
    }
    return null;
  };

  // methods & functions section

  const getFilter = () => {
    const filterArr = [];

    let date = new Date();

    if (filterType === "archieve") {
      date = filterArchieveDate;
      if (filterArchieveDate) {
        filterArr.push(
          `tanggal_berangkat:>=:${format(
            filterArchieveDate,
            "yyyy-MM-dd"
          )} 00:00:00`
        );
        filterArr.push(
          `tanggal_berangkat:<=:${format(
            filterArchieveDate,
            "yyyy-MM-dd"
          )} 23:59:59`
        );
      }
    } else if (filterType === "done") {
      filterArr.push(`status:=:4`);
      filterArr.push(
        `tanggal_berangkat:>=:${format(new Date(), "yyyy-MM-dd")} 00:00:00`
      );
    } else if (filterType === "pending") {
      filterArr.push(`status:=:3`);
      filterArr.push(
        `tanggal_berangkat:>=:${format(new Date(), "yyyy-MM-dd")} 00:00:00`
      );
    }

    return filterArr.join(";");
  };

  const resetEditorError = () => {
    setEditorError({});
  };

  const validateData = () => {
    let valid = true;
    return valid;
  };

  // const convertSaveData = (data) => {
  //   if (data.tanggal_berangkat) {
  //     data.tanggal_berangkat =
  //       format(data.tanggal_berangkat, "yyyy-MM-dd") +
  //       format(data.tanggal_berangkat_jam, " HH:mm:00");
  //   }
  //   if (data.tanggal_permintaan) {
  //     data.tanggal_permintaan = format(
  //       data.tanggal_permintaan,
  //       "yyyy-MM-dd HH:mm:ss"
  //     );
  //   }

  //   if (data.data_tujuan) {
  //     data.tujuan_nama = data.data_tujuan.nama;
  //   }

  //   data.keterangan = JSON.stringify({
  //     pemakai: data.keterangan_pemakai,
  //     pnj: data.keterangan_pnj,
  //     disetujui: data.keterangan_disetujui,
  //     diproses: data.keterangan_diproses,
  //   });

  //   return data;
  // };

  const getKeterangan = (label, value) => {
    try {
      if (value.length > 0) {
        const json = JSON.parse(value);
        return json[label] ?? "-";
      }
    } catch (e) {
      return "-";
    }
    return "-";
  };

  // const reformatAfterFetch = (data) => {
  //   if (data.tanggal_berangkat) {
  //     data.tanggal_berangkat = new Date(data.tanggal_berangkat);
  //     data.tanggal_berangkat_jam = new Date(data.tanggal_berangkat);
  //   }
  //   if (data.tanggal_permintaan) {
  //     data.tanggal_permintaan = new Date(data.tanggal_permintaan);
  //   }

  //   const keteranganPemakai = getKeterangan("pemakai", data.keterangan);
  //   const keteranganPnj = getKeterangan("pnj", data.keterangan);
  //   const keteranganDisetujui = getKeterangan("disetujui", data.keterangan);
  //   const keteranganDiproses = getKeterangan("diproses", data.keterangan);

  //   data.keterangan_pemakai = keteranganPemakai;
  //   data.keterangan_pnj = keteranganPnj;
  //   data.keterangan_disetujui = keteranganDisetujui;
  //   data.keterangan_diproses = keteranganDiproses;

  //   return data;
  // };

  // handle UI events section

  const handleOnReload = async () => {
    setPaging({ ...paging, filter: "" });
    fetchListData({
      page: paging.page,
      take: paging.take,
    });
  };

  // const handleOnEdit = async (row) => {
  //   setAddNewMode(false);
  //   resetEditorError();
  //   const newData = await fetchData({ id: row.id });
  //   if (newData) {
  //     const _newData = reformatAfterFetch(newData);
  //     setEditorData({ ..._newData });
  //     setEditorDialogShowed(true);
  //   }
  // };

  // const handleSaveOnlyEditor = async (data) => {
  //   const newData = await savePemakaianMobilData({ data });
  //   if (newData) {
  //     return reformatAfterFetch(newData);
  //   }
  //   return null;
  // };

  // const handleReloadEditor = async (data) => {
  //   if (data) {
  //     const revData = reformatAfterFetch(data);
  //     if (addNewMode) {
  //       setListData([revData, ...listData]);
  //     } else {
  //       const index = listData.findIndex((el) => el.id === revData.id);
  //       const newListData = [...listData];
  //       newListData.splice(index, 1, revData);
  //       setListData(newListData);
  //       setEditorData({ ...revData });
  //     }
  //   }
  // };

  const handleConfirmEditor = async (data, close = true) => {
    const dataPemakaianMobil = await savePemakaianMobilData({ data });
    if (dataPemakaianMobil) {
      const { permintaan_pemakaian_id } = data;

      if (permintaan_pemakaian_id) {
        const index = listData.findIndex(
          (el) => el.id === permintaan_pemakaian_id
        );
        if (index >= 0) {
          const parentData = listData[index];
          parentData.data_pemakaian_mobil = dataPemakaianMobil;
          parentData.pemakaian_mobil_id = dataPemakaianMobil.id;

          setEditorDialogShowed(false);
        }
      }
    }
  };

  const handleOnClickProses = async (event, row) => {
    const { data_pemakaian_mobil } = row;
    if (data_pemakaian_mobil) {
      const data = await fetchDataPemakaianMobil({
        id: data_pemakaian_mobil.id,
      });
      const _newData = {
        ...data,
        permintaan_pemakaian_id: row.id,
      };
      if (_newData.tanggal_perkiraan_berangkat)
        _newData.tanggal_perkiraan_berangkat_jam = new Date(
          _newData.tanggal_perkiraan_berangkat
        );

      setEditorData(_newData);
    } else {
      setEditorData({
        kendaraan_id: null,
        data_kendaraan: null,
        supir_id: null,
        data_supir: null,
        pemakai_id: row.pemakai_id,
        data_pemakai: row.data_pemakai,
        tanggal_transaksi: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        tanggal_perkiraan_berangkat: row.tanggal_berangkat,
        tanggal_perkiraan_berangkat_jam: new Date(row.tanggal_berangkat),
        jumlah_orang: row.jumlah_orang,
        keterangan: getKeterangan("pemakai", row.keterangan),
        tujuan_id: row.tujuan_id,
        data_tujuan: row.data_tujuan,
        permintaan_pemakaian_id: row.id,
        speedo_mulai: 0,
        speedo_akhir: 0,
      });
    }
    setEditorDialogShowed(true);
  };

  const handleOnClickDelete = (row) => {
    const accept = async () => {
      if (loading) return;
      await deleteData({ ids: [row.id] });
      setEditorDialogShowed(false);
    };
    const reject = () => { };

    confirmDialog({
      message: "Menghapus 1 data, lanjutkan?",
      header: "Konfirmasi",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  // UI section

  /**
   * Generate Table Column
   *
   * various function to generate
   * genTemplateBodyAction({ row, onEdit, onDelete })
   * genTemplateBodyText({ row, field, defaultEmpty })
   * genTemplateBodyNumber({ row, field, defaultEmpty, maxFraction, minFraction })
   * genTemplateBodyDate({ row, field, format })
   * genTemplateBodyImage({ row, field })
   */
  const actionBodyTemplate = (row) => {
    return (
      <div className="row-center-center">
        <Button
          icon="pi pi-pencil"
          className="max-h-[2rem]"
          onClick={(event) => handleOnClickProses(event, row)}
          label="Proses"
        />
      </div>
    );
  };

  const berangkatBodyTemplate = (row) => {
    const {
      tanggal_berangkat,
      data_tujuan,
      jumlah_orang,
      perkiraan_durasi,
      keterangan,
    } = row;
    return (
      <div className="col-start-start">
        <span className="font-semibold pb-1">
          {tanggal_berangkat
            ? format(new Date(tanggal_berangkat), "dd MMM yyyy - HH:mm")
            : "-"}
        </span>
        <div className="row-start-center gap-2">
          <span className="text-sm font-semibold">
            Ke {data_tujuan ? data_tujuan.nama : "-"}
          </span>
          <span className="text-sm">( {perkiraan_durasi} )</span>
        </div>
        <span className="text-sm pb-1">{jumlah_orang} Orang</span>
        <span className="text-sm italic">
          {getKeterangan("pemakai", keterangan)}
        </span>
      </div>
    );
  };

  const pemakaiBodyTemplate = (row) => {
    const {
      data_verif_pemakai,
      data_verif_pnj,
      data_verif_setujui,
      data_verif_tolak,
      keterangan,
      status,
    } = row;

    let tagSeverity;
    const tagMessage = getLabelStatusPermintaanMobil(status);

    if (status < 0) {
      tagSeverity = "danger";
    } else if (status < 3) {
      tagSeverity = "primary";
    } else {
      tagSeverity = "success";
    }

    return (
      <div className="h-full col-start-start">
        <span className="font-semibold pb-1">
          {data_verif_pemakai.nama} ( {data_verif_pemakai.title} )
        </span>
        <div className="row-start-start gap-2">
          <span className="text-sm italic">PNJ: </span>
          <span className="text-sm italic text-slate-400 font-semibold">
            {data_verif_pnj ? data_verif_pnj.nama : "-"}{" "}
          </span>
        </div>
        <div className="row-start-start gap-2 pb-1">
          <span className="text-sm italic">Disetujui: </span>
          <span className="text-sm italic text-slate-400 font-semibold">
            {data_verif_setujui ? data_verif_setujui.nama : "-"}{" "}
          </span>
        </div>
        <Tag value={tagMessage} severity={tagSeverity} />
      </div>
    );
  };

  const mobilBodyTemplate = (row) => {
    const { data_pemakaian_mobil } = row;

    if (data_pemakaian_mobil) {
      const { data_kendaraan, data_supir, tanggal_perkiraan_berangkat } =
        data_pemakaian_mobil;

      let nomorPolisi = "-";
      let namaSupir = "-";
      let jenisMobil = "-";

      if (data_kendaraan) {
        nomorPolisi = data_kendaraan.nomor_polisi;
        jenisMobil = data_kendaraan.jenis_mobil;
      }

      if (data_supir) {
        namaSupir = data_supir.nama;
      }

      return (
        <div className="col-start-start">
          <span className="">{nomorPolisi}</span>
          <span className="text-sm italic">{jenisMobil}</span>
          <div className="row-start-center gap-2 pb-2">
            <span className="text-sm italic">Supir:</span>
            <span className="text-sm font-semibold italic text-slate-400">
              {namaSupir}
            </span>
          </div>
          <span className="">
            {tanggal_perkiraan_berangkat
              ? format(
                new Date(tanggal_perkiraan_berangkat),
                "dd MMM yyy - HH:mm"
              )
              : "??"}
          </span>
        </div>
      );
    }

    return "-";
  };

  const mobileBodyTemplate = (row) => {
    const {
      status,
      tanggal_permintaan,
      tanggal_berangkat,
      keterangan,
      perkiraan_durasi,
      jumlah_orang,
      data_tujuan,
      data_pemakaian_mobil,
    } = row;

    let nomorPolisi = "";
    let namaSupir = "";
    let jenisMobil = "";
    let tanggalPerkiraanBerangkat = null;

    let tagSeverity;
    const tagMessage = getLabelStatusPermintaanMobil(status);

    if (status < 0) {
      tagSeverity = "danger";
    } else if (status < 3) {
      tagSeverity = "primary";
    } else {
      tagSeverity = "success";
    }

    if (data_pemakaian_mobil) {
      const { data_kendaraan, data_supir, tanggal_perkiraan_berangkat } =
        data_pemakaian_mobil;

      if (data_kendaraan) {
        nomorPolisi = data_kendaraan.nomor_polisi;
        jenisMobil = data_kendaraan.jenis_mobil;
      }

      if (data_supir) namaSupir = data_supir.nama;

      if (tanggal_perkiraan_berangkat)
        tanggalPerkiraanBerangkat = tanggal_perkiraan_berangkat;
    }

    return (
      <div className="col-start-start">
        <div className="row-start-center gap-3">
          <span className="font-semibold">
            {tanggal_berangkat
              ? format(new Date(tanggal_berangkat), "dd MMM yyyy - HH:mm")
              : "-"}
          </span>
          <span>-</span>
          <span className="text-sm font-semibold">
            {data_tujuan ? data_tujuan?.nama : "-"}
          </span>
        </div>
        <div className="row-start-center gap-3">
          <span className="text-sm">( {perkiraan_durasi} ),</span>
          <span className="text-sm">{jumlah_orang} orang</span>
        </div>
        <div className="col-start-start w-full py-2">
          <span className="text-sm italic text-slate-400">
            ~ {getKeterangan("pemakai", keterangan)} ~
          </span>
        </div>

        {nomorPolisi && namaSupir && jenisMobil && (
          <div className="col-start-start">
            <span className="">{nomorPolisi}</span>
            <span className="text-sm italic">{jenisMobil}</span>
            <div className="row-start-center gap-2 pb-2">
              <span className="text-sm italic">Supir:</span>
              <span className="text-sm font-semibold italic text-slate-400">
                {namaSupir}
              </span>
            </div>
            <span className="">
              {tanggalPerkiraanBerangkat
                ? format(
                  new Date(tanggalPerkiraanBerangkat),
                  "dd MMM yyy - HH:mm"
                )
                : "??"}
            </span>
          </div>
        )}

        <div className="row-end-center w-full pt-1 gap-2">
          <Tag value={tagMessage} severity={tagSeverity} />
          <Button
            icon="pi pi-pencil"
            rounded
            severity="success"
            className="bg-emerald-400 max-w-[1.85rem] max-h-[1.85rem]"
            onClick={() => handleOnClickProses(row)}
            pt={{ icon: { className: "!text-xs" } }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ConfirmDialog />
      <EditorDialog
        title={"Proses Permintaan Mobil"}
        verifSetting={verifSetting}
        data={editorData}
        setData={setEditorData}
        addNewMode={addNewMode}
        loading={editorLoading}
        error={editorError}
        setError={setEditorError}
        visible={editorDialogShowed}
        onHide={() => setEditorDialogShowed(false)}
        onConfirm={handleConfirmEditor}
        onDelete={handleOnClickDelete}
      // onSaveOnly={handleSaveOnlyEditor}
      // onReload={handleReloadEditor}
      />
      <div className="elevated-card-tight-vertical flex flex-row justify-between items-center w-100 gap-4">
        <div className="flex flex-col sm:flex-row justify-start items-start sm:items-center gap-3 sm:gap-0">
          <div className="row-start-center gap-2">
            <RadioButton
              inputId="filter1"
              name="filter"
              value="archieve"
              checked={filterType === "archieve"}
              onChange={(e) => setFilterType(e.value)}
            />
            <span
              className={`text-sm ${filterType === "archieve" ? "text-slate-500" : "text-slate-400"
                } font-semibold`}
            >
              Arsip:
            </span>
            <Calendar
              disabled={filterType !== "archieve"}
              className="w-[13.5rem]"
              dateFormat="dd MM yy"
              showIcon
              value={filterArchieveDate}
              onChange={(e) => setFilterArchieveDate(e.value)}
            />
          </div>
          <Divider className="h-[1rem] hidden sm:flex" layout="vertical" />
          <div className="row-start-center gap-4 sm:gap-0 w-full">
            <div className="row-start-center sm:w-auto gap-2">
              <RadioButton
                inputId="filter2"
                name="filter"
                value="done"
                checked={filterType === "done"}
                onChange={(e) => setFilterType(e.value)}
              />
              <span
                className={`text-sm ${filterType === "done" ? "text-slate-500" : "text-slate-400"
                  } font-semibold`}
              >
                Selesai
              </span>
            </div>
            <Divider className="h-[1rem] hidden sm:flex" layout="vertical" />
            <div className="row-start-center sm:w-auto gap-2">
              <RadioButton
                inputId="filter2"
                name="filter"
                value="pending"
                checked={filterType === "pending"}
                onChange={(e) => setFilterType(e.value)}
              />
              <span
                className={`text-sm ${filterType === "pending" ? "text-slate-500" : "text-slate-400"
                  } font-semibold`}
              >
                Pending
              </span>
            </div>

            <div className="row-end-center flex-grow sm:hidden">
              <Button
                className=""
                icon="pi pi-refresh"
                onClick={handleOnReload}
                outlined
                rounded
              />
            </div>
          </div>
        </div>
        <Button
          className="hidden sm:flex"
          icon="pi pi-refresh"
          onClick={handleOnReload}
          outlined
          rounded
        />
      </div>
      {!isMobile && (
        <div className="elevated-card col-center-center w-100 gap-3">
          <div className={`row-center-center gap-2 w-100`}>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              editMode="cell"
              value={listData}
              selection={selectedData}
              onSelectionChange={(e) => setSelectedData(e.value)}
            >
              <Column headerClassName="w-[3rem]" selectionMode={"multiple"} />
              <Column
                header="Action"
                headerClassName="w-[8rem]"
                alignHeader={"center"}
                body={actionBodyTemplate}
              />
              <Column
                header="Berangkat"
                headerClassName="w-[15rem]"
                body={berangkatBodyTemplate}
              />
              <Column
                header="Pemakai"
                headerClassName="w-[15rem]"
                body={pemakaiBodyTemplate}
              />
              <Column
                header="Mobil"
                headerClassName="w-[15rem]"
                body={mobilBodyTemplate}
              />
              {/* <Column header="Keterangan" body={keteranganBodyTemplate} /> */}
            </DataTable>
          </div>
        </div>
      )}

      {isMobile && (
        <div className="elevated-card !px-4 !py-4 col-center-center w-100 gap-3">
          <DataTable
            dataKey="id"
            className="w-100"
            loading={loading}
            showGridlines
            stripedRows
            editMode="cell"
            value={listData}
            selection={selectedData}
            onSelectionChange={(e) => setSelectedData(e.value)}
          >
            <Column
              header="PERMINTAAN MOBIL"
              alignHeader={"left"}
              body={mobileBodyTemplate}
            />
          </DataTable>
        </div>
      )}
    </div>
  );
};

export default PermintaanMobilPage;
